import { Link } from "react-router-dom";
import { getEditorPicks } from "@/lib/catalog";

export default function EditorPicks() {
  const picks = getEditorPicks(5);
  const [lead, ...rest] = picks;
  if (!lead) return null;

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_1fr] lg:gap-8">
      <Link
        to={`/detail/${lead.id}`}
        className="group relative flex min-h-[340px] cursor-pointer flex-col justify-end overflow-hidden rounded-lg border border-background-200 bg-primary-900 p-6 md:min-h-[420px] md:p-8"
      >
        <img
          src={lead.heroImage || lead.poster}
          alt={`${lead.title} 剧照`}
          className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.03]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/55 to-primary-950/15" />
        <div className="relative">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 font-label text-[10px] font-bold uppercase tracking-[0.16em] text-primary-950">
            <i className="ri-award-line text-xs" />
            编辑首选
          </span>
          <h3 className="mt-3 font-heading text-2xl font-extrabold leading-tight text-background-50 md:text-[32px]">
            {lead.title}
          </h3>
          <p className="mt-1.5 font-label text-[11px] uppercase tracking-[0.18em] text-primary-200">
            {lead.titleEn} · {lead.year} · {lead.region}
          </p>
          <p className="mt-3 max-w-lg text-[13px] leading-relaxed text-primary-100/85 md:text-sm">
            {lead.tagline}
          </p>
          <span className="mt-5 inline-flex items-center gap-1.5 border-b border-accent-400/60 pb-0.5 font-label text-[12px] font-semibold text-accent-300">
            阅读完整解析
            <i className="ri-arrow-right-line text-xs" />
          </span>
        </div>
      </Link>

      <div className="flex flex-col">
        {rest.map((film, index) => (
          <Link
            key={film.id}
            to={`/detail/${film.id}`}
            className={`group flex cursor-pointer items-start gap-4 py-4 transition-colors hover:bg-background-100/70 ${
              index === 0 ? "pt-0" : "border-t border-background-200"
            }`}
          >
            <div className="relative h-[86px] w-[58px] shrink-0 overflow-hidden rounded-md border border-background-200 bg-secondary-100">
              <img
                src={film.poster}
                alt={`${film.title} 作品封面`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="font-heading text-[15px] font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {film.title}
                </h3>
                <span className="shrink-0 font-label text-[12px] font-semibold text-accent-700">
                  {film.score.toFixed(1)}
                </span>
              </div>
              <p className="mt-0.5 font-label text-[10px] uppercase tracking-wider text-foreground-400">
                {film.titleEn} · {film.year}
              </p>
              <p className="mt-1.5 line-clamp-2 text-[12px] leading-relaxed text-foreground-600">
                {film.summary}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}